export const copyToClipboard = text => {
    const el = document.createElement('textarea')
    el.value = text
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
}



// WEBPACK FOOTER //
// ./src/util/copy-to-clipboard.js